import { useEffect } from 'react';
import { RouterProvider } from 'react-router-dom';

// project imports
import router from 'routes';
import ThemeCustomization from 'themes';
import ScrollTop from 'components/ScrollTop';
import { ToastProvider } from 'contexts/ToastContext';
import { authService } from 'api/services';

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  useEffect(() => {
    // 앱 시작 시 잘못된 토큰 정리
    authService.clearInvalidToken();
  }, []);

  return (
    <ThemeCustomization>
      <ToastProvider>
      <ScrollTop>
        <RouterProvider router={router} />
      </ScrollTop>
      </ToastProvider>
    </ThemeCustomization>
  );
}
